import React, { useEffect } from 'react';

declare global {
  interface Window {
    InfogramEmbeds: {
      process: Function;
    };
  }
}

const loadInfogram = () => {
  if (window.InfogramEmbeds) {
    window.InfogramEmbeds.process();
  } else {
    const script = document.createElement('script');
    script.id = 'infogram-async';
    script.async = true;
    script.src = 'https://e.infogram.com/js/dist/embed-loader-min.js';
    document.getElementsByTagName('body')[0].appendChild(script);
  }
};

interface InfogramContainerProps {
  src: string;
}

export function InfogramContainer({ src }: InfogramContainerProps) {
  useEffect(() => {
    loadInfogram();
  }, []);

  const id = src.replace(/https?:\/\/[^/]*infogram.com\//, '');

  return <div key={`infogram-${id}`} className="infogram-embed" data-id={id} data-type="interactive" />;
}
